import * as React from 'react';
import { ReactSVG } from 'react-svg';
import styled from 'styled-components';
import Icon from '@material-ui/core/Icon';
import CampaignIcon from '@material-ui/icons/Announcement';

import DashboardIcon from '../../resources/icons/home_page.svg';
import InspectionsIcon from '../../resources/icons/inspections.svg';
import ReviewsIcon from '../../resources/icons/reviews.svg';
import UserPageIcon from '../../resources/icons/user_page.svg';
import SearchIcon from '../../resources/icons/search_page.svg';

import { SidebarMenuLink } from '../../molecules';
import { ROUTES } from '../../constants/routes';
import SidebarShell from '../AppShell/SidebarShell';
import useCanSendInspectorMotd from '../../hooks/useCanSendInspectorMotd';

const createIcon = (src: string) => (
  <Icon>
    <ReactSVG src={src} />
  </Icon>
);

const InspectorSidebar = () => {
  // Only the inspector a Super Admin designated in Settings > Message Setup can
  // send, so nobody else gets a Messages tab that would 403 on open.
  const { canSend } = useCanSendInspectorMotd();

  return (
    <SidebarShell>
      <SidebarMenuLink
        icon={() => createIcon(DashboardIcon)}
        to={ROUTES.DASHBOARD}
        title="Dashboard"
      />
      <SidebarMenuLink
        icon={() => createIcon(InspectionsIcon)}
        to={ROUTES.INSPECTIONS}
        title="Inspections"
      />
      <SidebarMenuLink
        icon={() => createIcon(ReviewsIcon)}
        to={ROUTES.REVIEWS}
        title="Reviews"
      />
      <SidebarMenuLink
        icon={() => createIcon(SearchIcon)}
        to={ROUTES.SEARCH_INSPECTOR}
        title="Search"
      />
      {canSend && (
        <SidebarMenuLink
          icon={() => <CampaignIcon />}
          to={ROUTES.INSPECTOR_MESSAGES}
          title="Messages"
        />
      )}
      <SidebarMenuLink
        icon={() => createIcon(UserPageIcon)}
        to={ROUTES.ACCOUNT}
        title="Account"
      />
    </SidebarShell>
  );
};

export const Hamburger = styled.div`
  display: none;
  @media only screen and (max-width: 840px) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    position: absolute;
    top: 12px;
    left: 12px;
    z-index: 3;
    border-radius: var(--radius-md);
    background: var(--neutral-0);
    box-shadow: var(--shadow-sm);
    color: var(--neutral-700);
    cursor: pointer;

    svg {
      width: 22px;
      height: 22px;
    }
  }
`;

export default InspectorSidebar;
